(function($) {
  "use strict";

  jQuery(document).ready(function(){

          
	       var $window_2 = $(window);
      $window_2.on('scroll', function () {
        var scroll = $window_2.scrollTop();
        if (scroll < 500) {
          $(".product-addtocart-sticky").removeClass("is-sticky-2");
        } else {
          $(".product-addtocart-sticky").addClass("is-sticky-2");
        }
      });

    /*----------------------------
 jQuery MeanMenu
------------------------------ */
    jQuery('#mobile-menu-active').meanmenu();	

    /*----------------------------
 wow js active
------------------------------ */
    new WOW().init();
    
    /*-------------------------
  showlogin toggle function
--------------------------*/
    $( '#showlogin' ).on('click', function() {
      $( '#checkout-login' ).slideToggle(900);
    }); 

    /*-------------------------
  showcoupon toggle function
--------------------------*/
    $( '#showcoupon' ).on('click', function() {
      $( '#checkout_coupon' ).slideToggle(900);
    });


    /*-------------------------
  Create an account toggle function
--------------------------*/
    $( '#cbox' ).on('click', function() {
      $( '#cbox_info' ).slideToggle(900);
    });

    /*-------------------------
  Create an account toggle function
--------------------------*/
    $( '#ship-box' ).on('click', function() {
      $( '#ship-box-info' ).slideToggle(1000);
    });	


    /*-------------------------
  Create an account toggle function
--------------------------*/
    $( '.side-show' ).on('click', function() {
      $( '.side-hide' ).slideToggle(300);
    });	



    /*--------------------------
   Countdown
---------------------------- */	
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<div class="cdown days"><span class="counting counting-2">%-D</span>days</div><div class="cdown hours"><span class="counting counting-2">%-H</span>hrs</div><div class="cdown minutes"><span class="counting counting-2">%M</span>mins</div><div class="cdown seconds"><span class="counting">%S</span>secs</div>'));
      });
    });

    /*---------------------
	counter
--------------------- */	  

    $('.counter').counterUp({
      delay: 10,
      time: 1000
    });
    
    
 
  $(".cart-plus-minus").prepend('<div class="dec qtybutton">-</div>');
  $(".cart-plus-minus").append('<div class="inc qtybutton">+</div>');
  $(".qtybutton").on("click", function() {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find("input").val(newVal);
  });


    /* Ajax Cart */
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },500);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1000);

    });    


    /*--------------------------
 scrollUp
---------------------------- */	
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    }); 
    
    /* Match Heigh */   

    $('.products-grid .single-product').matchHeight();
    $('.tab-active-3 .tab-total').matchHeight();
    $('.tab-content .products-grid .single-product').matchHeight();
    $('.wishlist-tile.single-product').matchHeight();
    $('.single-footer').matchHeight();
     $('.item').matchHeight();

	/* Show hide Option */  
    $( ".category-menu > nav > ul > li:gt(5)" ).addClass( "side-hide" );

    if ($('.side-show').hasClass("side-hide")) {
      $('.side-show').removeClass('side-hide');
    } 


    $('.side-show').on('click', function(){
      $(this).toggleClass('show-hide');
    });

    
    /* Hret disable */  
	$('.side-show a').removeAttr('href');


  });

})(jQuery);



